import type { BillingCycle, PlanTier } from "./enums";

/**
 * Single-select status tab. The empty string means "All".
 *
 * **Wire-shape note.** Spec §4.1 defines `Partner.managedAccounts(statusFilter:
 * [SubscriptionType!])` as an array. The dashboard uses Devias Tabs
 * (single-select) by design; the consumer must marshal `status` into the
 * array form before calling the resolver:
 *
 * ```ts
 * statusFilter: filters.status === "" ? [] : [filters.status]
 * ```
 */
export type PortfolioStatusTab = "" | "TRIAL" | "PAID" | "PAST_DUE" | "CLOSED";

export type PortfolioSortKey =
	| "newest"
	| "oldest"
	| "nameAsc"
	| "nameDesc"
	| "renewalSoonest"
	| "renewalLatest"
	| "amountHigh"
	| "amountLow";

export interface PortfolioFilters {
	status: PortfolioStatusTab;
	plan: PlanTier[];
	cycle: BillingCycle[];
	search: string;
}

export const emptyPortfolioFilters: PortfolioFilters = {
	status: "",
	plan: [],
	cycle: [],
	search: "",
};

export const DEFAULT_PORTFOLIO_SORT: PortfolioSortKey = "newest";
